import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export const formatBytes = (bytes: number, unit: string, decimals?: number) => {
  if (bytes === 0) {
    return `0 ${unit}`;
  }

  const B = unit.charAt(0);
  const k = 1024;
  const dm = decimals || 2;
  const sizes = [unit, `K${B}`, `M${B}`, `G${B}`, `T${B}`, `P${B}`, `E${B}`, `Z${B}`, `Y${B}`];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

@Pipe({
  name: 'tsxByteFormat',
  standalone: true,
})
export class TsxByteFormatPipe implements PipeTransform {
  private readonly unit: string;

  constructor(private readonly translateService: TranslateService) {
    this.unit = translateService.currentLang === 'en' ? 'B' : 'O';
  }

  transform(value: any, args?: any): any {
    if (parseInt(value, 10) >= 0) {
      value = formatBytes(+value, this.unit, +args);
    }
    return value;
  }
}
